import API from '../../../../commons/api/api';
import * as actionTypes from '../actions/type';

export const initialState = {
  isProcessingEmoji: false,
  type: '',
  videoEmoji: []
};

const videoEmojiReducers = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_VIDEO_EMOJI_REQUEST:
      return {
        ...state,
        isProcessingEmoji: true,
        type: action.type,
      };
    case actionTypes.GET_VIDEO_EMOJI_SUCCESS:
      return {
        ...state,
        isProcessingEmoji: false,
        type: action.type,
        videoEmoji: action.payload?.data?.data || [],
      };
    case actionTypes.GET_VIDEO_EMOJI_FAILED:
      return {
        ...state,
        isProcessingEmoji: false,
        type: action.type,
        videoEmoji: [],
      };
    default:
      return state;
  }
};

export default videoEmojiReducers;
